import axios from "../services/axios";

export const getAccessToken = async (recFunction) => {
  try {
  
    const accessToken = localStorage.getItem("jayeek_accessToken");
    const tokenExpiration = localStorage.getItem("rh_token_expiration");

    if (accessToken) {
      // Return accessToken if it's available and not expired
      return accessToken;
    }

    // If no token is available or expired, request a new one
    const payLoad = {
      client_id: process.env.REACT_APP_CLIENT_ID,
      client_secret: process.env.REACT_APP_CLIENT_SECRET,
      grant_type: process.env.REACT_APP_GRANT_TYPE,
    };

    const response = await axios.post("/token", payLoad);
    
    if (response.status === 200) {
      const { data } = response;
      
      // Set expiration to 1 hour from now
      const expirationTime = new Date().getTime() + 1 * 60 * 60 * 1000; // 1 hour from now
      localStorage.setItem("jayeek_access_token", data.access_token);
      localStorage.setItem("jayeek_refresh_token", data.refresh_token);
      localStorage.setItem("jayeek_token_expiration", expirationTime); // Save expiration time

      // Optional: Call the callback function if provided and valid
      if (typeof recFunction === "function") {
        recFunction();
      }

      return data.access_token;
    } else {
      console.error("Failed to fetch access token", response);
      return null;
    }
  } catch (error) {
    // Handle error (e.g., log it or show a message to the user)
    console.error("Error fetching access token:", error);
    return null;
  }
};
